import { forwardRef } from 'react';
import { WeavePageWrapStyles } from './weave-page-wrap.styles';

type Props = {
  children: React.ReactNode;
  id?: string;
};

export const WeavePageWrap = forwardRef<HTMLDivElement, Props>(({ children, id, ...rest }, ref) => (
  <div ref={ref} id={id} {...rest} className={WeavePageWrapStyles.componentDivStyle1}>
    {children}
  </div>
));

WeavePageWrap.displayName = 'WeavePageWrap';
